import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import CookieBanner from "@/components/CookieBanner";
import LandingPage from "@/pages/LandingPage";
import AffiliateLogin from "@/pages/AffiliateLogin";
import AffiliateRegister from "@/pages/AffiliateRegister";
import AffiliateDashboard from "@/pages/AffiliateDashboard";
import AffiliateCases from "@/pages/AffiliateCases";
import AffiliateCaseDetail from "@/pages/AffiliateCaseDetail";
import AdminDashboard from "@/pages/AdminDashboard";
import ConsilierDashboard from "@/pages/ConsilierDashboard";
import TermeniConditii from "@/pages/TermeniConditii";
import PoliticaConfidentialitate from "@/pages/PoliticaConfidentialitate";
import PoliticaCookies from "@/pages/PoliticaCookies";
import StatusCheckerPage from "@/pages/StatusCheckerPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/affiliate/login" element={<AffiliateLogin />} />
          <Route path="/affiliate/register" element={<AffiliateRegister />} />
          <Route path="/affiliate/dashboard" element={<AffiliateDashboard />} />
          <Route path="/affiliate/cases" element={<AffiliateCases />} />
          <Route path="/affiliate/cases/:id" element={<AffiliateCaseDetail />} />
          <Route path="/admin/login" element={<Navigate to="/affiliate/login" replace />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/consilier/dashboard" element={<ConsilierDashboard />} />
          <Route path="/termeni-conditii" element={<TermeniConditii />} />
          <Route path="/politica-confidentialitate" element={<PoliticaConfidentialitate />} />
          <Route path="/politica-cookies" element={<PoliticaCookies />} />
          <Route path="/verificare-dosar" element={<StatusCheckerPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
